// Add these polyfills at the very top
import { Buffer } from 'buffer'
import process from 'process'

// Make them globally available
window.global = window.global || window
window.Buffer = window.Buffer || Buffer
window.process = window.process || process


import '@az/starc-ui/themes/starc.css' 
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
